<template>
  <div class="right-wrap">
    <div class="right-content aqhb">
      <div class="bgColor"></div>
      <div class="title">安全环保</div>
      <div class="cont">
        <div class="dayNum">
          <span>安全生产</span>
          <label class="nums" v-for="(item, index) in safeDate" :key="index">{{
            item
          }}</label>

          <label class="dayText">天</label>
        </div>
        <div class="yaoItem">
          <a-row type="flex" justify="space-between">
            <a-col :span="24">
              <div class="name">窑头</div>
              <div class="itemList">
                <div class="items fenchen">
                  <label class="left">
                    <label class="tabName">烟气湿度</label>
                    <span>(%)</span>
                  </label>
                  <label class="val">{{ ytFc1 }}</label>
                </div>
                <div class="items fenchen">
                  <label class="left">
                    <label class="tabName">粉尘含量</label>
                    <span>(mg/m³)</span>
                  </label>
                  <label class="val">{{ ytFc2 }}</label>
                </div>
                <div class="items fenchen">
                  <label class="left">
                    <label class="tabName">烟气温度</label>
                    <span>(℃)</span>
                  </label>
                  <label class="val">{{ ytFc3 }}</label>
                </div>
              </div>
            </a-col>
            <a-col :span="24">
              <div class="name">窑尾</div>
              <div class="itemList">
                <div class="items fenchen">
                  <label class="left">
                    <label class="tabName">粉尘含量</label>
                    <span>(mg/m³)</span>
                  </label>
                  <label class="val">{{ ywFc }}</label>
                </div>
                <div class="items eryanghualiu">
                  <label class="left">
                    <label class="tabName">二氧化硫</label>
                    <span>(mg/m³)</span>
                  </label>
                  <label class="val">{{ ywEyhl }}</label>
                </div>
                <div class="items danyanghuawu">
                  <label class="left">
                    <label class="tabName">氮氧化物</label>
                    <span>(mg/m³)</span>
                  </label>
                  <label class="val">{{ ywDyhw }}</label>
                </div>
                <div class="items danyanghuawu">
                  <label class="left">
                    <label class="tabName">氧含量</label>
                    <span>(%)</span>
                  </label>
                  <label class="val">{{ ywYhl }}</label>
                </div>
                <div class="items danyanghuawu">
                  <label class="left">
                    <label class="tabName">一氧化碳</label>
                    <span>(%)</span>
                  </label>
                  <label class="val">{{ ywYyht }}</label>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <div class="right-content sbzt">
      <div class="bgColor"></div>
      <div class="title">设备状态</div>
      <div class="cont">
        <div class="dayNum">
          <span>连续生产</span>
          <label class="nums" v-for="(item, index) in LXDay" :key="index">{{
            item
          }}</label>
          <label class="dayText">天</label>
        </div>
        <div class="chart">
          <a-row :gutter="0" class="nhheight">
            <a-col :span="14">
              <myEcharts
                v-if="chartData1"
                id="chartData1"
                :height="chartData1.heightBox"
                :result="chartData1"
              ></myEcharts>
            </a-col>
            <a-col :span="10" class="itemRight">
              <div class="botsty left">
                <span
                  >在线设备：<span
                    style="
                      color: #ffa422;
                      font-size: 1.2rem;
                      font-weight: bolder;
                    "
                    >{{ deviceNum.deviceonline }}</span
                  ></span
                >
              </div>
              <div class="botsty left">
                <span
                  >设备总量：<span
                    style="
                      color: #ffa422;
                      font-size: 1.2rem;
                      font-weight: bolder;
                    "
                    >{{ deviceNum.devicecount }}</span
                  ></span
                >
              </div>
              <a-divider style="margin: 10px 0px" />
              <div class="botsty left">
                <span
                  >在线测点：<span
                    style="
                      color: #af5bff;
                      font-size: 1.2rem;
                      font-weight: bolder;
                    "
                    >{{ pointNum.onlinepoint }}</span
                  ></span
                >
              </div>
              <div class="botsty left">
                <span
                  >测点总量：<span
                    style="
                      color: #af5bff;
                      font-size: 1.2rem;
                      font-weight: bolder;
                    "
                    >{{ pointNum.allpoint }}</span
                  ></span
                >
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <div class="right-content znyj">
      <div class="bgColor"></div>
      <div class="title">智能预警</div>
      <div class="cont">
        <div class="item">
          <div class="name">视频预警</div>
          <div class="rightBox">
            <div class="kuang">
              <div class="hangItem">
                <label>{{ VideoAlarm.all }}</label>
                <label class="notCorrected">告警总数</label>
              </div>
              <div class="hangItem">
                <label>{{ VideoAlarm.nothandled }}</label>
                <label class="hasRectification">未处理</label>
              </div>
              <div class="hangItem">
                <label>{{ VideoAlarm.handled }}</label>
                <label class="acceptanceAnd">已处理</label>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="name">生产预警</div>
          <div class="rightBox">
            <div class="kuang">
              <div class="hangItem">
                <label>{{ productionwarning.total }}</label>
                <label class="notCorrected">报警总数</label>
              </div>
              <div class="hangItem">
                <label>{{ productionwarning.dealedTotal }}</label>
                <label class="hasRectification">已处理</label>
              </div>
              <div class="hangItem">
                <label>{{ productionwarning.unDealTotal }}</label>
                <label class="acceptanceAnd">未处理</label>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="name">设备预警</div>
          <div class="rightBox">
            <div class="kuang">
              <div class="hangItem">
                <label>0</label>
                <label class="notCorrected">未整改</label>
              </div>
              <div class="hangItem">
                <label>13</label>
                <label class="hasRectification">已整改</label>
              </div>
              <div class="hangItem">
                <label>9</label>
                <label class="acceptanceAnd">已验收</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpUrl from "../../views/httpUrl";
import myEcharts from "@/components/home/myEcharts.vue";
import { parseGeoJson } from "echarts";
export default {
  components: {
    myEcharts,
  },
  data() {
    return {
      safeDate: [], //安全生产天数
      LXDay: [], //连续生产天数
      chartData1: null,
      timeOut: null,
      ytTimeOut:null,
      timeOut10s:null,
      ytFc1: "",
      ytFc2: "",
      ytFc3: "",
      ywFc: "",
      ywEyhl: "",
      ywDyhw: "",
      ywYhl: "",
      ywYyht: "",
      VideoAlarm: {},
      deviceNum: {},
      pointNum: {},
      productionwarning: {},
    };
  },
  created() {

    
  },
  destroyed() {
    if (this.timeOut) {
      clearInterval(this.timeOut);
    }
    if (this.ytTimeOut) {
      clearInterval(this.ytTimeOut);
    }
    if (this.timeOut10s) {
      clearInterval(this.timeOut10s);
    }
  },
  mounted() {
    let _this =this
    window.addEventListener("resize", function () {
      _this.drawChart();
    });
    _this.drawChart();
    _this.getVideoAlarm();
    _this.getPointTest();
    _this.getSafeDate();
    _this.getLXDay();
    _this.initOnlineDevice();
    _this.getPointInfoCount();
    _this.getTotal();
    _this.getCountByLocType();

    _this.ytTimeOut = setInterval(function () {
      _this.getPointTest();
    }, 5000);

    _this.timeOut = setInterval(function () {
      _this.getSafeDate();
      _this.getLXDay();
      _this.initOnlineDevice();
      _this.getPointInfoCount();
      _this.getCountByLocType();
    }, 1800000);

    _this.timeOut10s = setInterval(function () {
      _this.getVideoAlarm();
      _this.getTotal();
    }, 10000);
  },
  methods: {
    //安全生产天数
    getSafeDate() {
      this.$myHttp
        .post(httpUrl.home.safeDate, {
          dictCode: "safe_date",
        })
        .then((res) => {
          this.safeDate = res.data.safeDate.toString().split("");
        })
        .catch((res) => {});
    },
    //连续生产时间
    getLXDay() {
      this.$myHttp
        .get(httpUrl.home.LXDay)
        .then((res) => {
          this.LXDay = res.data.lxday.toString().split("");
        })
        .catch((res) => {});
    },
    //窑头窑尾粉尘等监控
    getPointTest() {
      this.$myHttp
        .get(httpUrl.home.getPointTest)
        .then((res) => {
          this.ytFc1 = res.data.HEADFC1;
          this.ytFc2 = res.data.HEADFC2;
          this.ytFc3 = res.data.HEADFC3;

          this.ywFc = res.data.TAILFC;
          this.ywEyhl = res.data.TAILSO2;
          this.ywDyhw = res.data.TAILNO;
          this.ywYhl = res.data.TAILO2;
          this.ywYyht = res.data.TAILCO;
        })
        .catch((res) => {});
    },
    //视频预警
    getVideoAlarm() {
      let myDate = new Date();
      let time = myDate.toLocaleDateString().split("/").join("-");
      this.$myHttp({
        method: "post",
        url: httpUrl.home.getVideo,
        data: {
          entity: time,
          ext: 1,
        },
      })
        .then((res) => {})
        .catch((err) => {
          this.VideoAlarm = {
            all: err.ext.all,
            handled: err.ext.handled,
            nothandled: err.ext.nothandled,
          };
        });
    },
    //在线设备数
    initOnlineDevice() {
      this.$myHttp
        .get(httpUrl.home.initOnlineDevice)
        .then((res) => {
          this.deviceNum = res.data;
        })
        .catch((res) => {});
    },
    //在线测点数
    getPointInfoCount() {
      this.$myHttp
        .get(httpUrl.home.getPointInfoCount)
        .then((res) => {
          this.pointNum = res.data;
        })
        .catch((res) => {});
    },
    //工段饼图
    getCountByLocType() {
      this.$myHttp
        .get(httpUrl.home.getCountByLocType)
        .then((res) => {
          if (res.code === "200") {
            res.data.forEach(element => {
              element.name=element.name.replace('工段','')
            });
            this.chartData1.series[0].data = res.data;
            let mychart1 = this.$echarts.init(document.getElementById("chartData1"))
            mychart1.setOption(this.chartData1)
            window.addEventListener("resize", function() {
                mychart1.resize();
            });
          }
        })
        .catch((r) => {});
    },
    //生产预警
    getTotal() {
      this.$myHttp
        .get(httpUrl.home.selWaringTotal)
        .then((res) => {
          this.productionwarning = res.data;
        })
        .catch((res) => {});
    },
    RandomNumBoth(Min, Max) {
      var Range = Max - Min;
      var Rand = Math.random();
      var num = (Min + Rand * Range).toFixed(2);
      return num;
    },
    drawChart() {
      let _this = this;
      _this.chartData1 = {
        heightBox: $(".nhheight")[0].offsetHeight + "px",
        color: ["#259bfd", "#9f62ff", "#ffad1b"],
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["50%", "20%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "outside",
              distanceToLabelLine: 0 ,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "10",
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      };
    },
  },
};
</script>

<style lang="less">
.right-wrap {
  overflow: hidden;
  flex: 0 0 20%;
  display: flex;
  flex-direction: column;
  .right-content {
    position: relative;
    flex: 1;
    display: flex;
    border: 1px #0054ff solid;
    padding: 0.5rem 0.5rem 0 0.5rem;
    .bgColor {
      color: #fff;
      width: 96%;
      position: absolute;
      background: hsl(220, 100%, 50%);
      opacity: 0.3;
      line-height: 2.8rem;
      height: 2.8rem;
    }
    .title {
      color: white !important;
      position: absolute;
      line-height: 3rem;
      font-size: 1.1rem;
      width: 96%;
      padding-left: 1rem;
    }
    .cont {
      width: 100%;
      height:100%;
      padding: 4rem 0.7rem 0.7rem 0.7rem;
    }
  }
  // 安全环保
  .aqhb {
    .dayNum {
      span {
        font-size: 1rem;
        font-weight: bold;
      }
      .nums {
        padding: 0.1rem 0.3rem;
        background: #0054ff;
        color: #fff;
        font-weight: bold;
        font-size: 2rem;
        margin-left: 0.2rem;
      }
      .dayText {
        font-size: 1rem;
        font-weight: bold;
        margin-left: 0.5rem;
      }
    }
    .yaoItem {
      margin-top: 0.5rem;
      .name {
        color: #caddff;
        height: 2rem;
        line-height: 2rem;
        background: #02145f;
        text-align: center;
        font-size: 1rem;
      }
      .itemList {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        .items {
          width: 48%;
          height: 1.5rem;
          line-height: 1.5rem;
          background: rgba(2, 20, 95, 0.2);
          margin: 0.3rem 0;
          label {
            display: inline-block;
          }
          .left{
            width: 60%;
            .tabName {
              width: 54%;
              font-size: .8rem;
              color: #fff;
              display: inline-block;
              text-align: justify;
              text-align-last: justify;
            }
          }
          .val {
            color: #00f0ff;
            font-weight: bold;
            font-size: 1rem;
            width: 35%;
            text-align: right;
          }
        }
      }
    }
  }
  //设备状态
  .sbzt {
    margin: 1rem 0;
    .dayNum {
      span {
        font-size: 1rem;
        font-weight: bold;
      }
      .nums {
        padding: 0.1rem 0.3rem;
        background: #0054ff;
        color: #fff;
        font-weight: bold;
        font-size: 2rem;
        margin: 0 0.2rem;
      }
      .dayText {
        margin-left: 0.5rem;
        font-size: 1rem;
        font-weight: bold;
      }
    }
    .chart {
      width: 100%;
      height: calc(100% - 80px);
      .nhheight {
        height: 100% ;
  
        .itemRight {
          padding-left: 1rem;
          .botsty {
            color: white;
            background: #02145f;
            width: 100%;
            line-height: 1.7rem;
            height: 1.7rem;
          }
          .left {
          }
          .right {
            padding-left: 0;
          }
        }
      }
    }
  }
  //智能预警
  .znyj {
    .item {
      height: 5rem;
      .name {
        width: 5%;
        word-wrap: break-word;
        display: inline-block;
        float: left;
        color: #3ffffc;
      }
      .rightBox {
        width: 95%;
        display: inline-block;
        .kuang {
          height: 4.8rem;
          background: url("../../assets/picture/right/early_warning.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .hangItem {
            margin: 0 1rem;
            text-align: center;
            display: inline-block;
            display: flex;
            flex-direction: column;
            .notCorrected {
              color: #f94b62;
              font-weight: bold;
            }
            .hasRectification {
              color: #a6c3ff;
              font-weight: bold;
            }
            .acceptanceAnd {
              color: #99f106;
              font-weight: bold;
            }
            label:first-child {
              color: #b9ceff;
              font-size: 1.6rem;
              font-weight: bold;
            }
            label:last-child {
              font-size: 0.5rem;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/rightPart.vue